import React from "react";
import { Link, PartScrollPos, Icon } from "nystem-components";
import "./iconmenu.css";

const PartIconmenu = () => (
  <PartScrollPos>
    {({ scrollTop, height }) => {
      const pos = 20 - parseInt((scrollTop / height) * 500, 10);
      return (
        <div
          className="icon-menu"
          style={{ left: pos < -200 ? -200 : pos + "px" }}
        >
          <div>
            <Link to="/hitta-hit" aria-label="Karta">
              <Icon className="h-10 w-10" icon="location-dot" />
            </Link>
          </div>
          <div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              href="https://www.instagram.com/yintangakupunktur/"
            >
              <Icon className="h-10 w-10" icon="brands-instagram" />
            </a>
          </div>
          <div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              href="https://www.facebook.com/yintangakupunktur/"
            >
              <Icon
                className="h-10 w-10"
                icon="brands-facebook-square"
              />
            </a>
          </div>
        </div>
      );
    }}
  </PartScrollPos>
);
export default PartIconmenu;
